<script>
	import { getContext } from 'svelte'
	import { admin } from '../../../library/scripts/PhpHandler.svelte'
	import { downloadUrl } from '../../../library/scripts/Setup.svelte'
	import { getCookie } from '../../../library/scripts/cookie'
	import { get_old_bookings_pdf } from '../AdminModule.svelte'
	import { styles } from '../../../library/scripts/styles'
	import { storeOldBookings } from '../../../library/scripts/Store.svelte'
	import Spinner from '../../../library/ShadersAndSpinners/SpinnerCircle.svelte'
	import Shader from '../../../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../../../modals/Alert.svelte'

	const globals = getContext('globals')
	const fsXS = globals.fsXS
	const fsS = globals.fsS
	const fsN = globals.fsN
	const colorMain = globals.colorMain
	const colorError = globals.colorError
	const link = globals.link
	const linkHover = globals.linkHover
	const inputBgFocus = globals.inputBgFocus

	//the id
	const ID = getCookie('id')

	const noFilesMsg = 'no files yet'

	let oldBookings = get_old_bookings_pdf(ID)
	oldBookings.then((value) => {
		if (value === 'false' || value.length === 0) {
			storeOldBookings.set([])
		} else storeOldBookings.set(value)
	})

	//send delete
	let showAlert = false

	const close_alert = () => {
		showAlert = false
	}

	let deleteID = null
	const set_delete_booking = async (e) => {
		showAlert = true
		deleteID = e
	}

	const delete_booking = async () => {
		const deleteBooking = await admin({ cmd: 'delete_booking_pdf', id: ID, delFile: deleteID })
		storeOldBookings.set(deleteBooking)
		if (deleteBooking) showAlert = false
	}

	const download_booking = async (b) => {
		const createZip = await admin({ cmd: 'create_bk_zip', id: ID, zipFile: b })

		if (createZip) {
			// extract the filename
			const fileName = b.split('.')
			let a = document.createElement('a')
			a.href = downloadUrl + createZip[1] + '/' + createZip[2] + '/book_keeping/' + fileName[0] + '.zip'
			a.setAttribute('download', createZip[2])
			a.click()

			//giv e a timout for 10 seconds, then delete zip.file
			const toDeleteZip = setTimeout(async () => {
				const deleteZip = await admin({
					cmd: 'delete_zip_file',
					file: '../' + createZip[1] + '/' + createZip[2] + '/book_keeping/' + fileName[0] + '.zip',
				})

				clearTimeout(toDeleteZip)
			}, 3000)
		}
	}
</script>

{#await $storeOldBookings}
	<Spinner color={inputBgFocus} size="2vw" info="content loading" fontSize={fsXS} />
{:then bookings}
	<div class="container">
		{#if $storeOldBookings.length !== 0}
			{#each bookings as booking}
				<div class="booked_row" use:styles={{ fsS, colorMain }}>
					<div>{booking}</div>
					<div
						class="link"
						use:styles={{ link, linkHover }}
						on:click={() => download_booking(booking)}
						on:keydown={() => download_booking(booking)}
					>
						download
					</div>
					<div
						class="link"
						use:styles={{ link, linkHover }}
						on:click={() => set_delete_booking(booking)}
						on:keydown={() => set_delete_booking(booking)}
					>
						delete
					</div>
				</div>
			{/each}
		{:else}
			<div class="error" use:styles={{ fsN, colorError }}>{noFilesMsg}</div>
		{/if}
	</div>
{/await}

{#if showAlert}
	<Shader>
		<div slot="content">
			<Alert
				alertMessage="delete booking"
				message="!CAUTION!"
				message2="The book-keeping file will be deleted! This action cannot be undone!!"
				on:alertclose={close_alert}
				on:alertok={delete_booking}
			/>
		</div>
	</Shader>
{/if}

<style>
	.container {
		padding: 15px;
	}
	.booked_row {
		display: grid;
		grid-template-columns: clamp(30px, 13vw, 200px) clamp(30px, 3.9vw, 60px) clamp(30px, 3.9vw, 60px);
		column-gap: 10px;
		font-size: var(--fsS);
		color: var(--colorMain);
		margin-bottom: 15px;
	}

	.link {
		color: var(--link);
		cursor: pointer;
	}

	.link:hover {
		color: var(--linkHover);
	}

	.error {
		color: var(--colorError);
		font-size: var(--fsN);
	}
</style>
